import { render, staticRenderFns } from "./TaskRunList.vue?vue&type=template&id=1074831c&"
import script from "./TaskRunList.vue?vue&type=script&lang=js&"
export * from "./TaskRunList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports